const MILLISECONDS_IN_SECONDS = 1000;

const makeChartData = dayArray => {
  if (dayArray) {
    // Gets an array of arrays of value and date time for each day
    // the original date time is the date time of the first entry
    // all other date times need to be calculated relative to the original date time, resolution and index
    return dayArray.flatMap(day =>
      day.values.map((value, index) => [
        day.date_time + day.resolution * MILLISECONDS_IN_SECONDS * index,
        value
      ])
    );
  }

  return [];
};

const getChartOptions = (
  ruleName,
  alertColour,
  data,
  thresholds,
  yAxisTitle
) => {
  return {
    title: {
      text: ruleName ?? "",
      align: "left"
    },
    series: [
      {
        name: ruleName ?? "",
        type: "line",
        color: alertColour,
        data: data,
        label: {
          enabled: false
        },
        zIndex: 2
      },
      ...thresholds
    ],
    plotOptions: {
      series: {
        label: {
          enabled: true
        },
        marker: {
          symbol: "circle",
          lineWidth: 2,
          fillColor: "white",
          lineColor: null
        }
      }
    },
    tooltip: {
      valueDecimals: 2
    },
    xAxis: {
      type: "datetime",
      title: {
        text: "Date"
      }
    },
    yAxis: {
      title: {
        text: yAxisTitle
      }
    }
  };
};

export const getRawChartOptions = (
  ruleName,
  alertColour,
  data,
  thresholds,
  yAxisTitle
) => {
  const chartData = makeChartData(data);

  return getChartOptions(
    ruleName,
    alertColour,
    chartData,
    thresholds,
    yAxisTitle
  );
};
